import Axios, { InternalAxiosRequestConfig } from 'axios';

import { API_URL } from '@/config';
import storage from '@/utils/storage';
import { notifications } from '@mantine/notifications';

function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  const token = JSON.parse(storage.getToken());
  // TODO: Remove config.headers nullable validation
  config.headers = config.headers ?? {};

  if (token?.token) {
    config.headers['Authorization'] = `Bearer ${token.token}`;
  } else {
    config.headers['x-studiocast-apikey'] = import.meta.env.VITE_STUDIOCAST_APIKEY;
  }

  if (!config.headers['Content-Type'])
    config.headers['Content-Type'] = 'application/json';
  config.headers['Accept'] = '*/*';

  return config;
}

export const axios = Axios.create({
  baseURL: API_URL
});

axios.interceptors.request.use(authRequestInterceptor);

axios.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    // Ajout d'une notification d'erreur
    const message = error.response?.data?.message || error.message;
    // notifications.show({
    //   title: 'Error',
    //   message,
    // });

    return Promise.reject(error);
  }
);
